import { render, staticRenderFns } from "./LdGatedButton.vue?vue&type=template&id=ea569850"
import script from "./LdGatedButton.vue?vue&type=script&lang=js"
export * from "./LdGatedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports